<template>
  <div id="pagination">
    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-6">
          <div class="pull-left">
            <label style="margin-top: 1em;">
              Total {{ total }} items
              <select v-model="per_page">
                <option>20</option>
                <option>50</option>
                <option>100</option>
                <option>200</option>
              </select>
              Per Page
            </label>
          </div>
        </div>

        <div class="col-sm-6">
          <paginate
            v-model="page"
            :page-count="last_page"
            :page-range="3"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  name: 'PaginateTable',
  props: ['page', 'per_page', 'last_page', 'total'],
  data: () => ({
    page: page,
    per_page: per_page,
  }),
  watch: {
    page(val) {
      this.emit()
    },
    per_page(val) {
      this.page = 1

      this.emit()
    },
  },
  components: {
    Paginate,
  },
  mounted() {
    this.emit()
  },
  methods: {
    emit() {
      const pagination = {
        page: this.page,
        per_page: this.per_page,
      }

      this.$emit('input', pagination)
    },
    clickCallback: function(pageNum) {
      //console.log(pageNum);
    },
  },
}
</script>

<style lang="scss">
.pagination {
  float: right;
}
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  z-index: 3;
  color: #fff !important;
  cursor: default;
  background-color: #00a350;
  border-color: #0d944f;
}
</style>
